module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create":"Create user","searchPlaceholder":"Name"},"de":{"create":"Neuer Benutzer","searchPlaceholder":"Name"},"fr":{"create":"Nouvel utilisateur","searchPlaceholder":"Nom"},"it":{"create":"Nuovo utente","searchPlaceholder":"Nome"}}')
  delete Component.options._Ctor
}
